"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXPORT_STATUS = exports.EXPORT_TYPE = void 0;
var EXPORT_TYPE;
(function (EXPORT_TYPE) {
    EXPORT_TYPE["CHAT"] = "CHAT";
    EXPORT_TYPE["MEDIA"] = "MEDIA";
    EXPORT_TYPE["RPM"] = "RPM";
})(EXPORT_TYPE || (exports.EXPORT_TYPE = EXPORT_TYPE = {}));
var EXPORT_STATUS;
(function (EXPORT_STATUS) {
    EXPORT_STATUS["COMPLETED"] = "COMPLETED";
    EXPORT_STATUS["IN_PROGRESS"] = "IN_PROGRESS";
    EXPORT_STATUS["FAILED"] = "FAILED";
})(EXPORT_STATUS || (exports.EXPORT_STATUS = EXPORT_STATUS = {}));
